/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Fragment } from 'react';
import type {
  ArticleStubType,
  PromoLinksListType,
} from '../../../../constants';
import { ArticlePromo } from './ArticlePromo';
import { ListPromo } from './ListPromo';

type Props = {
  /**
   * An array of "promo areas", either an `article-stub` or `link-list`
   */
  promo?: Array<ArticleStubType | PromoLinksListType>;
  /**
   * Function called when closing menu on a link from within the MegaMenu
   */
  onCloseMenu?: () => void;
};

const Styles = {
  root: css({
    display: 'flex',
    flexDirection: 'column',
  }),
  divider: css({
    backgroundColor: 'var(--zds-gray-warm-5: #B5B2AA)',
    height: 1,
    margin: '20px 0',

    '&:last-of-type': {
      display: 'none',
    },
  }),
};

/**
 * @private
 * Promotional content for the MegaMenu
 */
export const Promo = (props: Props) => {
  const { promo } = props;
  return promo ? (
    <div css={Styles.root} data-testid="promo" data-zds>
      {promo.map((item, index) => (
        <Fragment key={`${item.type}-${index}`}>
          {item.type === 'article-stub' ? (
            <ArticlePromo
              {...(item as ArticleStubType)}
              onCloseMenu={props.onCloseMenu}
            />
          ) : (
            <ListPromo
              {...(item as PromoLinksListType)}
              onCloseMenu={props.onCloseMenu}
            />
          )}
          <hr css={Styles.divider} data-zds />
        </Fragment>
      ))}
    </div>
  ) : null;
};
